import React, { Component } from "react";
import { Modal, Card } from "react-bootstrap";
import { FormGroup, Col, Row } from "reactstrap";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { SelectArticle } from "../../redux/actions/GetArticles";
import { TextField, Fab } from "@material-ui/core";
import "../styling/Styling.scss";
import "./ss.scss";
import Center from "react-center";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { withStyles } from "@material-ui/styles";
// import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
// import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";



const stylesFn = () => ({
  input: {
    color: "#fff",
  },
  root: {
    "& label.Mui-focused": {
      color: "#fff",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "#fff",
      },
      "&:hover fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff",
      },
    },
  },
});

// const roundTo = require("round-to");

class LigBCArticlel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codearticle: "",
      qte: "",
      totalht: 0,
      des: "",
      unite: "",
      puht: "",
      remisea: 0,
      codtvaa: "",
      tva: 0,
      puttcnet: 0,
      faudec: "",
      tab: [],
      totalqte: 0,
      sumremisearticle: 0,
      totalhtbrut: 0,
      totaltva: 0,
      totalhtnet: 0,
      remiseglobal: 0,
      totalFodec:0, 
      codbar: "",
      avance: 0,
      stkfin: 0,
      stkmg: 0,
      netapayer: 0,
      snackbaropen: false,
      snackbarfail: false,
      editModalShow: false,
      qtte: 0,
      btnEnabled: false,
      gilad: true,
      rechs: [],
      netnetapayer: 0,
      clicked: false,
      changeButton: false,
      pmp: "",
    };
  }

  componentDidMount() {
    this.props.SelectArticle(
      this.props.ConfigDossier.coddos,
      this.props.ConfigDossier.serveur,
      this.props.ConfigDossier.utilisateur,
      this.props.ConfigDossier.pwd_serveur,
      this.props.ConfigDossier.database
    );
    this.setState({
      totalqte: this.props.totalqte,
      sumremisearticle: this.props.sumremisearticle,
      totalhtbrut: this.props.totalhtbrut,
      totaltva: this.props.totaltva,
      totalFodec:this.props.totalFodec,
      totalhtnet: this.props.totalhtnet,
      remiseglobal: this.props.remiseglobal,
      netapayer: this.props.netapayer,
      btnEnabled: this.props.btnEnabled,
      netnetapayer: this.props.netnetapayer,
      avance: this.props.avance,
      datfac: this.props.defaultdate,
      valtimbre: this.props.valtimbre,
    });
  }

  componentDidUpdate(prevprops, prevstate) {
    if (prevprops.tabArticle != this.props.tabArticle) {
      this.setState({
        tab: this.props.tabArticle,
      });
    }
  }

  articleHandlerChange = (event) => {
    fetch(
      `https://www.24-crm.tn/webservice/api/ARTICLEs?codartt=${event.target.value}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    )
      .then((response) => response.json())
      .then((data) => this.setState({ rechs: data, clicked: true }));
  };

  snackbarClose = (event) => {
    this.setState({ snackbaropen: false });
  };

  snackbarFailClose = (event) => {
    this.setState({ snackbarfail: false });
  };

  qteHandler = (event) => {
    console.log(typeof parseInt(event.target.value));
    console.log(typeof this.state.totalqte);

    this.setState({
      qte: event.target.value,
      puttcnet: Number(this.state.puht * (1 + this.state.tva / 100)).toFixed(3),
      totalht: Number(
        event.target.value *
          this.state.puht *
          ((100 - this.state.remisea) / 100)
      ).toFixed(3),
    });
  };

  remiseHandler = (event) => {
    this.setState({
      remisea: event.target.value,
      totalht: Number(
        this.state.qte * this.state.puht * ((100 - event.target.value) / 100)
      ).toFixed(3),
      puttcnet: Number(
        this.state.puht *
          (1 + this.state.tva / 100) *
          ((100 - event.target.value) / 100)
      ).toFixed(3),
    });
  };

  puhtHandler = (event) => {
    this.setState({
      puht: event.target.value,
      totalht: Number(
        this.state.qte * event.target.value * ((100 - this.state.remisea) / 100)
      ).toFixed(3),
      puttcnet: Number(
        event.target.value *
          (1 + this.state.tva / 100) *
          ((100 - this.state.remisea) / 100)
      ).toFixed(3),
    });
  };

  puttcHandler = (event) => {
    this.setState({
      puttcnet: event.target.value,
      puht: Number(
        event.target.value /
          ((100 - this.state.remisea) / 100) /
          (1 + this.state.tva / 100)
      ).toFixed(3),
      totalht: Number(
        this.state.qte *
          ((event.target.value /
            ((100 - this.state.remisea) / 100) /
            (1 + this.state.tva / 100)) *
            ((100 - this.state.remisea) / 100))
      ).toFixed(3),
    });
  };

  onCellChange = (event) => {
    this.setState({ codearticle: event.target.value });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  deleteRow = (index) => {
    var tab = [...this.state.tab];
    tab.splice(index, 1);
    const SumQte = tab && tab.reduce((a, v) => a + parseInt(v.qte), 0);
    const SumRemiseArticle =
      tab &&
      tab.reduce((a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100, 0);
      const SumHtBrut =
      tab && tab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
    // const SumTva =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       parseInt(v.qte) *
    //         v.puht *
    //         ((100 - v.remisea) / 100) *
    //         ((100 - this.props.rem) / 100) *
    //         (v.tva / 100),
    //     0
    //   );
       const SumHtNet =
      tab &&
      tab.reduce((a, v) => a + v.totalht * ((100 - this.props.rem) / 100), 0);
      const SumFodec =
     SumHtNet*
      Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) /
      100;
    const taufodec = Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0);
const applyFodec = this.props.showFodec && this.state.faudec;

const SumTva =
  tab &&
  tab.reduce((a, v) => {
    const base =
      parseInt(v.qte) *
      v.puht *
      ((100 - v.remisea) / 100) *
      ((100 - this.props.rem) / 100);

    // Add FODEC before TVA if both booleans are true
    const baseWithFodec = applyFodec
      ? base * (1 + taufodec / 100)
      : base;

    const tvaAmount = baseWithFodec * (v.tva / 100);

    return a + tvaAmount;
  }, 0);

 
    const SumRemiseGlobale =
      tab && tab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
      const SumNetAPayer =SumHtNet+SumFodec+SumTva;
    const Avance = (SumNetAPayer * this.props.regimecli) / 100;
    const SumNetNetAPayer =
      SumNetAPayer + parseFloat(this.props.valtimbre) + Avance;

    this.setState({
      tab,
      totalqte: SumQte,
      sumremisearticle: SumRemiseArticle,
      totalhtbrut: SumHtBrut,
      totaltva: SumTva,
      totalFodec:SumFodec,
      totalhtnet: SumHtNet,
      remiseglobal: SumRemiseGlobale,
      netapayer: SumNetAPayer,
      snackbarfail: true,
      avance: Avance,
      netnetapayer: SumNetNetAPayer,
    });

    this.setState({
      codearticle: "",
      qte: "",
      totalht: 0,
      des: "",
      unite: "",
      puht: "",
      remisea: 0,
      tva: 0,
      puttcnet: 0,
      faudec: "",
      stkfin: 0,
    });
  };

  modifiermodification = (event) => {
    // event.preventDefault();

    const newtab = this.state.tab.concat({
      codearticle: this.state.codearticle,
      des: this.state.des,
      qte: this.state.qte,
      unite: this.state.unite,
      puht: this.state.puht,
      faudec: this.state.faudec,
      remisea: this.state.remisea,
      codtvaa: this.state.codtvaa,
      codbar: this.state.codbar,
      tva: this.state.tva,
      puttcnet: this.state.puttcnet,
      totalht: this.state.totalht,
      pmp: this.state.pmp,
    });
    // const SumQte = newtab && newtab.reduce((a, v) => a + parseInt(v.qte), 0);
    // const SumRemiseArticle =
    //   newtab &&
    //   newtab.reduce(
    //     (a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100,
    //     0
    //   );
    // const SumHtBrut =
    //   newtab && newtab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
    // const SumTva =
    //   newtab &&
    //   newtab.reduce(
    //     (a, v) =>
    //       a +
    //       parseInt(v.qte) *
    //         v.puht *
    //         ((100 - v.remisea) / 100) *
    //         ((100 - this.props.rem) / 100) *
    //         (v.tva / 100),
    //     0
    //   );
    // const SumHtNet =
    //   newtab &&
    //   newtab.reduce(
    //     (a, v) => a + v.totalht * ((100 - this.props.rem) / 100),
    //     0
    //   );
    // const SumRemiseGlobale =
    //   newtab &&
    //   newtab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
    // const SumNetAPayer =
    //   newtab &&
    //   newtab.reduce(
    //     (a, v) =>
    //       a +
    //       (v.totalht * ((100 - this.props.rem) / 100) +
    //         v.qte * v.puht * ((100 - v.remisea) / 100) * (v.tva / 100)),
    //     0
    //   );
    // const Avance = (SumNetAPayer * this.props.regimecli) / 100;
    // const SumNetNetAPayer =
    //   Number(SumNetAPayer) + Number(this.props.valtimbre) + Avance;
    const SumQte = newtab && newtab.reduce((a, v) => a + parseInt(v.qte), 0);
    const SumRemiseArticle =
      newtab &&
      newtab.reduce(
        (a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100,
        0
      );
    const SumHtBrut =
      newtab && newtab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
 
    const SumHtNet =
      newtab &&
      newtab.reduce(
        (a, v) => a + v.totalht * ((100 - this.props.rem) / 100),
        0
      );
    const SumFodec =
    SumHtNet*
    Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) /
    100;
    const taufodec = Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0);
const applyFodec = this.props.showFodec && this.state.faudec;

const SumTva =
newtab &&
newtab.reduce((a, v) => {
  const base =
    parseInt(v.qte) *
    v.puht *
    ((100 - v.remisea) / 100) *
    ((100 - this.props.rem) / 100);

  // Add FODEC before TVA if both booleans are true
  const baseWithFodec = applyFodec
    ? base * (1 + taufodec / 100)
    : base;

  const tvaAmount = baseWithFodec * (v.tva / 100);

  return a + tvaAmount;
}, 0);

 
    const SumRemiseGlobale =
      newtab &&
      newtab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
    // const SumNetAPayer =
    //   newtab &&
    //   newtab.reduce(
    //     (a, v) =>
    //       a +
    //       (v.totalht * ((100 - this.props.rem) / 100) +
    //         v.qte * v.puht * ((100 - v.remisea) / 100) * (v.tva / 100)),
    //     0
    //   );
    const SumNetAPayer =SumHtNet+SumFodec+SumTva;
    const Avance = (SumNetAPayer * this.props.regimecli) / 100;
    const SumNetNetAPayer =
      Number(SumNetAPayer)  + Avance;
    
    this.setState({
      tab: newtab,

      totalqte: SumQte,
      sumremisearticle: SumRemiseArticle,
      totalhtbrut: SumHtBrut,
      totaltva: SumTva,
      totalFodec:SumFodec,
      totalhtnet: SumHtNet,
      remiseglobal: SumRemiseGlobale,
      netapayer: SumNetAPayer,
      snackbaropen: true,
      btnEnabled: true,
      avance: Avance,
      netnetapayer: SumNetNetAPayer,
      changeButton: false,
    });

    this.setState({
      codearticle: "",
      qte: "",
      totalht: 0,
      des: "",
      unite: "",
      puht: 0,
      remisea: 0,
      tva: 0,
      codtvaa: "",
      codbar: "",
      puttcnet: 0,
      faudec: "",
      pmp: "",
      stkfin: 0,
    });
  };

  submitHandler = (event) => {
    event.preventDefault();
    if (
      this.state.tab.filter((el) => el.codearticle == this.state.codearticle)
        .length > 0
    ) {
      alert("article existant ");
    } else if (
      this.props.tabArticle
        .filter((el) => el.codearticle == this.state.codearticle)
        .filter((el) => this.state.qte > el.qte).length > 0
    ) {
      alert("la quantité dépasse celle de la facture ");
    } else {
      const newtab = this.state.tab.concat({
        codearticle: this.state.codearticle,
        des: this.state.des,
        qte: this.state.qte,
        unite: this.state.unite,
        puht: this.state.puht,
        faudec: this.state.faudec,
        remisea: this.state.remisea,
        codtvaa: this.state.codtvaa,
        tva: this.state.tva,
        puttcnet: this.state.puttcnet,
        codbar: this.state.codbar,
        totalht: this.state.totalht,
        pmp: this.state.pmp,
      });
      // const SumQte = newtab && newtab.reduce((a, v) => a + parseInt(v.qte), 0);
      // const SumRemiseArticle =
      //   newtab &&
      //   newtab.reduce(
      //     (a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100,
      //     0
      //   );
      // const SumHtBrut =
      //   newtab && newtab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
      // const SumTva =
      //   newtab &&
      //   newtab.reduce(
      //     (a, v) =>
      //       a +
      //       parseInt(v.qte) *
      //         v.puht *
      //         ((100 - v.remisea) / 100) *
      //         ((100 - this.props.rem) / 100) *
      //         (v.tva / 100),
      //     0
      //   );
      // const SumHtNet =
      //   newtab &&
      //   newtab.reduce(
      //     (a, v) => a + v.totalht * ((100 - this.props.rem) / 100),
      //     0
      //   );
      // const SumRemiseGlobale =
      //   newtab &&
      //   newtab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
      // const SumNetAPayer =
      //   newtab &&
      //   newtab.reduce(
      //     (a, v) =>
      //       a +
      //       (v.totalht * ((100 - this.props.rem) / 100) +
      //         v.qte * v.puht * ((100 - v.remisea) / 100) * (v.tva / 100)),
      //     0
      //   );
      // const Avance = (SumNetAPayer * this.props.regimecli) / 100;
      // const SumNetNetAPayer =
      //   SumNetAPayer + parseFloat(this.props.valtimbre) + Avance;
      const SumQte = newtab && newtab.reduce((a, v) => a + parseInt(v.qte), 0);
      const SumRemiseArticle =
        newtab &&
        newtab.reduce(
          (a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100,
          0
        );
      const SumHtBrut =
        newtab && newtab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
   
      const SumHtNet =
        newtab &&
        newtab.reduce(
          (a, v) => a + v.totalht * ((100 - this.props.rem) / 100),
          0
        );
      const SumFodec =
      SumHtNet*
      Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) /
      100;
      const taufodec = Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0);
const applyFodec = this.props.showFodec && this.state.faudec;

const SumTva =
  newtab &&
  newtab.reduce((a, v) => {
    const base =
      parseInt(v.qte) *
      v.puht *
      ((100 - v.remisea) / 100) *
      ((100 - this.props.rem) / 100);

    // Add FODEC before TVA if both booleans are true
    const baseWithFodec = applyFodec
      ? base * (1 + taufodec / 100)
      : base;

    const tvaAmount = baseWithFodec * (v.tva / 100);

    return a + tvaAmount;
  }, 0);

   
      const SumRemiseGlobale =
        newtab &&
        newtab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
     
      const SumNetAPayer =SumHtNet+SumFodec+SumTva;
      const Avance = (SumNetAPayer * this.props.regimecli) / 100;
      const SumNetNetAPayer =
        Number(SumNetAPayer)  + Avance;
      
      this.setState({
        tab: newtab,

        totalqte: SumQte,
        sumremisearticle: SumRemiseArticle,
        totalhtbrut: SumHtBrut,
        totaltva: SumTva,
        totalFodec:SumFodec,
        totalhtnet: SumHtNet,
        remiseglobal: SumRemiseGlobale,
        netapayer: SumNetAPayer,
        snackbaropen: true,
        btnEnabled: true,
        avance: Avance,
        netnetapayer: SumNetNetAPayer,
      });

      // console.log("SumHtNettt", SumHtNet);

      this.setState({
        codearticle: "",
        qte: "",
        totalht: 0,
        des: "",
        unite: "",
        puht: 0,
        remisea: 0,
        codtvaa: "",
        codbar: "",
        tva: 0,
        puttcnet: 0,
        faudec: "",
        pmp: "",
        stkfin: 0,
      });
    }
  };

  deleteRowMod = (index) => {
    var tab = [...this.state.tab];
    tab.splice(index, 1);
    // const SumQte = tab && tab.reduce((a, v) => a + parseInt(v.qte), 0);
    // const SumRemiseArticle =
    //   tab &&
    //   tab.reduce((a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100, 0);
    // const SumHtBrut =
    //   tab && tab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
    // const SumTva =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       parseInt(v.qte) *
    //         v.puht *
    //         ((100 - v.remisea) / 100) *
    //         ((100 - this.props.rem) / 100) *
    //         (v.tva / 100),
    //     0
    //   );
    // const SumHtNet =
    //   tab &&
    //   tab.reduce((a, v) => a + v.totalht * ((100 - this.props.rem) / 100), 0);
    // const SumRemiseGlobale =
    //   tab && tab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
    // const SumNetAPayer =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       (v.totalht * ((100 - this.props.rem) / 100) +
    //         parseInt(v.qte) *
    //           v.puht *
    //           ((100 - v.remisea) / 100) *
    //           (v.tva / 100)),
    //     0
    //   );
    const SumQte = tab && tab.reduce((a, v) => a + parseInt(v.qte), 0);
    const SumRemiseArticle =
      tab &&
      tab.reduce((a, v) => a + (parseInt(v.qte) * v.puht * v.remisea) / 100, 0);
    const SumHtBrut =
      tab && tab.reduce((a, v) => a + parseInt(v.qte) * v.puht, 0);
    // const SumTva =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       parseInt(v.qte) *
    //         v.puht *
    //         ((100 - v.remisea) / 100) *
    //         ((100 - this.props.rem) / 100) *
    //         (v.tva / 100),
    //     0
    //   );
    const SumHtNet =
        tab &&
        tab.reduce(
          (a, v) => a + v.totalht * ((100 - this.props.rem) / 100),
          0
        );
      const SumFodec =
      SumHtNet*
      Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) /
      100;
    const taufodec = Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0);
    const applyFodec = this.props.showFodec && this.state.faudec;
    
    const SumTva =
    tab &&
    tab.reduce((a, v) => {
      const base =
        parseInt(v.qte) *
        v.puht *
        ((100 - v.remisea) / 100) *
        ((100 - this.props.rem) / 100);

      // Add FODEC before TVA if both booleans are true
      const baseWithFodec = applyFodec
        ? base * (1 + taufodec / 100)
        : base;

      const tvaAmount = baseWithFodec * (v.tva / 100);

      return a + tvaAmount;
    }, 0);
    
    const SumRemiseGlobale =
      tab && tab.reduce((a, v) => a + v.totalht * (this.props.rem / 100), 0);
    // const SumNetAPayer =
    //   tab &&
    //   tab.reduce(
    //     (a, v) =>
    //       a +
    //       (v.totalht * ((100 - this.props.rem) / 100) +
    //         parseInt(v.qte) *
    //           v.puht *
    //           ((100 - v.remisea) / 100) *
    //           (v.tva / 100)),
    //     0
    //   );
    const SumNetAPayer =SumHtNet+SumFodec+SumTva;

    const Avance = (SumNetAPayer * this.props.regimecli) / 100;
    const SumNetNetAPayer =
      Number(SumNetAPayer)  + Avance;
    this.setState({
      tab,
      totalqte: SumQte,
      sumremisearticle: SumRemiseArticle,
      totalhtbrut: SumHtBrut,
      totaltva: SumTva,
      totalFodec:SumFodec,
      totalhtnet: SumHtNet,
      remiseglobal: SumRemiseGlobale,
      netapayer: SumNetAPayer,
      btnEnabled: true,
    });
  };

  render() {
    let editModalClose = () => this.setState({ editModalShow: false });

    const { darck, classes } = this.props;
    const sommeTotalHT = this.state.tab.reduce((total, t) => total + Number(t.puttcnet), 0);
    const sommeQuantité = this.state.tab.reduce((total, t) => total + Number(t.qte), 0);
    return (
      <div className="container">
        <Snackbar
          open={this.state.snackbaropen}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={this.snackbarClose}
        >
          <Alert
            style={{ height: "50px" }}
            onClose={this.snackbarClose}
            severity="success"
          >
            Article ajouté
          </Alert>
        </Snackbar>

        <Snackbar
          open={this.state.snackbarfail}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={this.snackbarFailClose}
        >
          <Alert
            style={{ height: "50px" }}
            onClose={this.snackbarFailClose}
            severity="error"
          >
            Article supprimé
          </Alert>
        </Snackbar>

        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header
            closeButton
            style={{
              backgroundColor: `${darck ? "#fff" : "#172431"}`,
              color: `${darck ? "#020F64" : "#fff"}`,
              borderTop: `${darck ? "" : "2px solid #fff"}`,
              borderRight: `${darck ? "" : "2px solid #fff"}`,
              borderLeft: `${darck ? "" : "2px solid #fff"}`,
              borderBottom: `none`,
            }}
          >
            <Modal.Title id="contained-modal-title-vcenter">
              <b>Articles</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              backgroundColor: `${darck ? "#fff" : "#172431"}`,
              borderTop: `none`,
              borderRight: `${darck ? "" : "2px solid #fff"}`,
              borderLeft: `${darck ? "" : "2px solid #fff"}`,
              borderBottom: `${darck ? "" : "2px solid #fff"}`,
            }}
          >
            <Row>
              <Col style={{ margin: "0" }}>
                <Card>
                  <Card.Body
                    style={{
                      backgroundColor: `${darck ? "#fff" : "#172431"}`,
                      border: `${darck ? "" : "2px solid #fff"}`,
                    }}
                  >
                    <form
                      autocomplete="off"
                      className={`${darck ? "" : classes.root}`}
                      onSubmit={this.submitHandler}
                    >
                      <b style={{ color: `${darck ? "" : "#fff"}` }}>
                        Chercher article:
                      </b>

                      <b style={{ marginLeft: "10px" }}>
                          {this.state.faudec === "V" ? (
                            <p style={{ color: "blue" }}>Fodec: ✔</p>
                          ) : null}
                        </b>

                      <Row form>
                        <Col sm={3}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              options={this.props.articles.articles}
                              // options={this.state.rechs}
                              // options={
                              //   this.state.clicked
                              //     ? this.state.rechs
                              //     : this.props.articles.articles
                              // }
                              getOptionLabel={(option) => option.codart}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unite: getOptionLabel.unite,
                                      puht: Number(
                                        getOptionLabel.PUDHT
                                      ).toFixed(3),
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      codtvaa: getOptionLabel.codtva,
                                      codbar: getOptionLabel.codbar,
                                      pmp: getOptionLabel.pmp,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unite: "",
                                      puht: "",
                                      remisea: 0,
                                      codtvaa: "",
                                      codbar: "",
                                      tva: 0,
                                      faudec: "",
                                      pmp: "",
                                    });
                                getOptionLabel && this.props.GMM
                                  ? fetch(
                                      `https://www.24-crm.tn/webservice/api/MAGASIN?codep=${this.props.MG}&codart=${getOptionLabel.codart}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
                                    )
                                      .then((res) => res.json())
                                      .then((res) =>
                                        res.map((el) =>
                                          this.setState({ stkfin: el.StkFin })
                                        )
                                      )
                                  : getOptionLabel
                                  ? this.setState({
                                      stkfin: getOptionLabel.stkfin,
                                    })
                                  : this.setState({ stkfin: 0 });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // {...params}
                                  ////codeEEE
                                  label="Code"
                                  // className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}
                                  onSelect={this.magasinHandlerChange}
                                  InputProps={{
                                    ...params.InputProps,
                                    className: !darck
                                      ? this.props.classes.input
                                      : null,
                                  }}
                                  disabled={params.disabled}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              //   options={this.props.articles.articles}
                              // options={this.state.rechs}
                              options={
                                this.state.clicked
                                  ? this.state.rechs
                                  : this.props.articles.articles
                              }
                              getOptionLabel={(option) => option.desart}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unite: getOptionLabel.unite,
                                      puht: Number(
                                        getOptionLabel.PUDHT
                                      ).toFixed(3),
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      codtvaa: getOptionLabel.codtva,
                                      codbar: getOptionLabel.codbar,
                                      pmp: getOptionLabel.pmp,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unite: "",
                                      puht: "",
                                      remisea: 0,
                                      codtvaa: "",
                                      codbar: "",
                                      tva: 0,
                                      faudec: "",
                                      pmp: "",
                                    });
                                getOptionLabel && this.props.GMM
                                  ? fetch(
                                      `https://www.24-crm.tn/webservice/api/MAGASIN?codep=${this.props.MG}&codart=${getOptionLabel.codart}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
                                    )
                                      .then((res) => res.json())
                                      .then((res) =>
                                        res.map((el) =>
                                          this.setState({ stkfin: el.StkFin })
                                        )
                                      )
                                  : getOptionLabel
                                  ? this.setState({
                                      stkfin: getOptionLabel.stkfin,
                                    })
                                  : this.setState({ stkfin: 0 });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // {...params}
                                  label="Désignation"
                                  // className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}   
                                  InputProps={{
                                    ...params.InputProps,
                                    className: !darck
                                      ? this.props.classes.input
                                      : null,
                                  }}
                                  disabled={params.disabled}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={3}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              //   options={this.props.articles.articles}
                              // options={this.state.rechs}
                              options={
                                this.state.clicked
                                  ? this.state.rechs
                                  : this.props.articles.articles
                              }
                              getOptionLabel={(option) => option.codbar}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unite: getOptionLabel.unite,
                                      puht: Number(
                                        getOptionLabel.PUDHT
                                      ).toFixed(3),
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      codtvaa: getOptionLabel.codtva,
                                      codbar: getOptionLabel.codbar,
                                      pmp: getOptionLabel.pmp,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unite: "",
                                      puht: "",
                                      remisea: 0,
                                      codtvaa: "",
                                      codbar: "",
                                      tva: 0,
                                      faudec: "",
                                      pmp: "",
                                    });
                                getOptionLabel && this.props.GMM
                                  ? fetch(
                                      `https://www.24-crm.tn/webservice/api/MAGASIN?codep=${this.props.MG}&codart=${getOptionLabel.codart}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
                                    )
                                      .then((res) => res.json())
                                      .then((res) =>
                                        res.map((el) =>
                                          this.setState({ stkfin: el.StkFin })
                                        )
                                      )
                                  : getOptionLabel
                                  ? this.setState({
                                      stkfin: getOptionLabel.stkfin,
                                    })
                                  : this.setState({ stkfin: 0 });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  // {...params}
                                  label="Code à barre"
                                  // className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}
                                  InputProps={{
                                    ...params.InputProps,
                                    className: !darck
                                      ? this.props.classes.input
                                      : null,
                                  }}
                                  disabled={params.disabled}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row form>
                        <Col sm={3}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Code article"
                              value={this.state.codearticle}
                              disabled
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Désignation"
                              value={this.state.des}
                              disabled
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={1}>
                          <FormGroup>
                            {/* {this.state.des === "" ? (
                              <TextField
                                id="standard-basic"
                                label="Quantité"
                                type="number"
                                disabled
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                style={{ marginTop: "16px" }}
                                margin="normal"
                                fullWidth
                                required
                              />
                            ) : ( */}
                            <TextField
                              id="standard-basic"
                              label="Qte"
                              type="number"
                              value={this.state.qte}
                              onChange={this.qteHandler}
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              fullWidth
                              required
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                shrink: true,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                            {/* )} */}
                          </FormGroup>
                        </Col>
                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              value={`Stock: ${this.state.stkfin}`}
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              disabled
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row form>
                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Unité"
                              value={this.state.unite}
                              fullWidth
                              disabled
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="PU HT"
                              value={this.state.puht}
                              fullWidth
                              name="puht"
                              onChange={this.puhtHandler}
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Remise %"
                              value={this.state.remisea}
                              fullWidth
                              name="remisea"
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              onChange={this.remiseHandler}
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="TVA"
                              value={this.state.tva}
                              fullWidth
                              disabled
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="PU TTC Net"
                              value={this.state.puttcnet}
                              fullWidth
                              onChange={this.puttcHandler}
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Total HT"
                              value={Number(this.state.totalht).toFixed(3)}
                              fullWidth
                              disabled
                              // className="card add-input"
                              margin="dense"
                              variant="outlined"
                              InputProps={{
                                className: !darck
                                  ? this.props.classes.input
                                  : null,
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                              InputLabelProps={{
                                style: {
                                  color: !darck ? "#fff" : null,
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      {this.state.des === "" ? (
                        <Center>
                          <Button
                            disabled
                            style={{ width: "250px" }}
                            variant="contained"
                            color="primary"
                            type="submit"
                          >
                            Ajouter
                          </Button>
                        </Center>
                      ) : (
                        <Center>
                          <Button
                            style={{ width: "250px" }}
                            variant="contained"
                            color="primary"
                            type="submit"
                          >
                            Ajouter
                          </Button>
                        </Center>
                      )}
                    </form>
                  </Card.Body>
                </Card>

                <Card style={{ marginTop: "10px" }}>
                  <Card.Body
                    style={{
                      backgroundColor: `${darck ? "#fff" : "#172431"}`,
                      border: `${darck ? "" : "2px solid #fff"}`,
                    }}
                  >
                    {/* <div className="lig-table"> */}
                    <div className="tabd28">
                      <table style={{ marginTop: "10px" }}>
                        <thead
                          style={{ fontSize: "12px", textAlign: "center" }}
                        >
                          <tr>
                          <th>Code</th>
                            <th style={{ width: "37%" }}>
                              {" "}
                              Désignation{" "}
                            </th>
                            <th> Quantité </th>
 {Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) !== 0 &&(<th>Fodec</th>)}
                            <th> PUHT</th>
                            <th>Remise</th>
                            <th> TVA </th>
                            <th> PUTTCNet </th>
                            <th> TotalHT</th>
                            <th></th>
                            <th></th>
                          </tr>
                        </thead>

                        <tbody  
                        style={{
                            overflowY: "auto",
                            display: "block",
                            maxHeight: "10em",
                            textAlign: "center",
                            color: `${darck ? "" : "#fff"}`,
                          }}>
                          {this.state.tab.map((t, i) => (
                            <tr key={i}>
                              <td>
                                <span>{t.codearticle}</span>
                              </td>
                              <td style={{ fontSize: "12px", width: "37%" }}>
                                <span> {t.des} </span>
                              </td>
                              <td>
                                {" "}
                                <span> {t.qte}</span>
                              </td>
                              {Number(this.props.InfoEntreprise?.[0]?.taufodec ?? 0) !== 0 &&( <td>
                                <span>
                                  {t.faudec?.toLowerCase() === "v" ? "✔" : "✖"}
                                </span>
                              </td>)}
                                <td>
                                {" "}
                                <span> {Number(t.puht).toFixed(2)}</span>
                              </td>
                              <td>
                                {" "}
                                <span> {Number(t.remisea).toFixed(2)}</span>
                              </td>
                              <td>
                                {" "}
                                <span> {Number(t.tva).toFixed(2)}</span>
                              </td>
                              <td>
                                {" "}
                                <span> {Number(t.puttcnet).toFixed(3)}</span>
                              </td>
                              <td>
                                {" "}
                                <span> {Number(t.totalht).toFixed(2)}</span>
                              </td>
                              <td>
                                <Tooltip title="Modifier cet article">
                                  <Fab size="small">
                                    <EditIcon
                                      style={{}}
                                      onClick={() => {
                                        this.setState({
                                          codearticle: t.codearticle,
                                          des: t.des,
                                          unite: t.unite,
                                          puht: t.puht,
                                          remisea: t.remisea,
                                          tva: t.tva,
                                          faudec: t.faudec,
                                          qte: t.qte,
                                          totalht: t.totalht,
                                          puttcnet: t.puttcnet,
                                          codtvaa: t.codtvaa,
                                          pmp: t.pmp,
                                          changeButton: true,
                                        });
                                        this.deleteRowMod(i);
                                      }}
                                    />
                                  </Fab>
                                </Tooltip>
                              </td>
                              <td>
                                <Tooltip title="Supprimer cet article">
                                  <Fab size="small">
                                    <DeleteIcon
                                      style={{}}
                                      onClick={() => this.deleteRow(i)}
                                    />
                                  </Fab>
                                </Tooltip>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    
                    
  {/*Pour l'affichager de la totale de quantité et somme prixTTC */}
                    <Row style={{ marginBottom: "-15px", marginTop: "10px" ,marginLeft: "10px"  }}>
  <Col style={{ marginRight: "2px", marginLeft: "450px" }}>
    <p style={{ color: `${darck ? "#008000" : "#008000"}`, fontWeight: "bold", fontSize: "13px", margin: "0" }}>
      Total QTé : </p><p style={{ color: darck ? "#008000" : "#008000", fontWeight: "bold", margin: "0 -10px 0 0" }}>
        {sommeQuantité.toFixed(3)} </p> </Col>
  <Col style={{ marginRight: "2px", marginLeft: "-20px" }}>
    <p style={{ color: `${darck ? "#008000" : "#008000"}`, fontWeight: "bold", fontSize: "13px", margin: "0" }}>Total prix :</p><p style={{ color: darck ? "#008000" : "#008000", fontWeight: "bold", margin: "0" }}>{sommeTotalHT.toFixed(3)}  </p></Col>
</Row> 

      


                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer
            style={{
              backgroundColor: `${darck ? "" : "#172431"}`,
              borderTop: `none`,
              borderRight: `${darck ? "" : "2px solid #fff"}`,
              borderLeft: `${darck ? "" : "2px solid #fff"}`,
              border: `${darck ? "" : "2px solid #fff"}`,
            }}
          >
            {this.state.tab != this.props.tabArticle ? (
              <>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "rgb(0, 8, 126)",
                    color: "white",
                    width: "30%",
                  }}
                  onClick={() => {
                    this.props.submitHandler(
                      this.state.tab,
                      this.state.totalqte,
                      this.state.sumremisearticle,
                      this.state.totalhtbrut,
                      this.state.totaltva,
                      this.state.totalFodec,
                      this.state.totalhtnet,
                      this.state.remiseglobal,
                      this.state.netapayer,
                      this.state.btnEnabled,
                      this.state.avance,
                      this.state.netnetapayer,
                      this.state.codtvaa,
                      this.state.pmp
                    );
                    // this.enregistrer();
                    this.props.onHide();
                  }}
                >
                  Enregistrer
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                style={{
                  color: "white",
                  width: "30%",
                }}
                disabled
                // onClick={() => {
                //   this.props.submitHandler(
                //     this.state.tab,
                //     this.state.totalqte,
                //     this.state.sumremisearticle,
                //     this.state.totalhtbrut,
                //     this.state.totaltva,
                //     this.state.totalhtnet,
                //     this.state.remiseglobal,
                //     this.state.netapayer,
                //     this.state.btnEnabled,
                //     this.state.netnetapayer
                //   );
                // this.enregistrer();
                //   this.props.onHide();
                // }}
              >
                Enregistrer
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SelectArticle: (a, b, c, d, e) => dispatch(SelectArticle(a, b, c, d, e)),
  };
}

function mapStateToProps(state) {
  return {
    articles: state.articles,
    ConfigDossier: state.ConfigDossier,
    darck: state.darck.darck,
    InfoEntreprise: state.InfoDossier,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(stylesFn)(LigBCArticlel));
